import type { ReactNode } from 'react';
import { cn } from '../lib/cn';
import { Label } from './Label';
import { FieldMessage } from './FieldMessage';

export type FieldProps = {
  /** Field caption — string or rich content (e.g. label + tooltip). */
  label: ReactNode;
  htmlFor?: string;
  optional?: boolean;
  hint?: string;
  /** Validation message (string or rich node). */
  error?: ReactNode;
  children: ReactNode;
  className?: string;
};

/**
 * Label + control + hint/error.
 * The message slot always reserves one line so validation does not layout-shift.
 *
 * Control chrome: pass `invalid` to kit `Input` / `Textarea` / `Select` when
 * `error` is set — Field does not clone children to inject borders.
 */
export function Field({
  label,
  htmlFor,
  optional,
  hint,
  error,
  children,
  className,
}: FieldProps) {
  return (
    <div className={cn('flex flex-col gap-1', className)}>
      <Label
        {...(htmlFor != null ? { htmlFor } : {})}
        {...(optional ? { optional: true } : {})}
        className="items-center"
      >
        {label}
      </Label>
      {children}
      <FieldMessage
        {...(error != null ? { error } : {})}
        {...(hint != null ? { hint } : {})}
      />
    </div>
  );
}
